import { render, staticRenderFns } from "./fundsTransfer.vue?vue&type=template&id=9f837074&scoped=true&"
import script from "./fundsTransfer.vue?vue&type=script&lang=js&"
export * from "./fundsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./fundsTransfer.vue?vue&type=style&index=0&id=9f837074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f837074",
  null
  
)

export default component.exports